import { render, staticRenderFns } from "./type_docmgt.vue?vue&type=template&id=688beac8"
import script from "./type_docmgt.vue?vue&type=script&lang=js"
export * from "./type_docmgt.vue?vue&type=script&lang=js"
import style0 from "./type_docmgt.vue?vue&type=style&index=0&id=688beac8&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports